import type { DeviceType } from "@/types";

/**
 * 物件検索の「一覧 API どれを叩くか・/properties なら device_type を何にするか」の分岐。
 * バックエンドのドメイン型ではなく、このアプリの検索画面だけの整理用。
 *
 * - PabbitLite → GET /buildings & device_type=PabbitLite
 * - PATMO → GET /properties & device_type=PATMO
 * - dearisController → dearis* 4 種いずれも GET /properties & device_type=dearisController
 */
export type ObjectSearchRoute = "PabbitLite" | "PATMO" | "dearisController";

const OBJECT_SEARCH_DEARIS_CONTROLLER_DEVICE_TYPES = [
  "dearisController",
  "dearisGate",
  "dearisEntrance",
  "dearisElevator",
] as const satisfies readonly DeviceType[];

export function getObjectSearchRoute(deviceType: DeviceType): ObjectSearchRoute | null {
  if (deviceType === "PabbitLite") return "PabbitLite";
  if (deviceType === "PATMO") return "PATMO";
  if ((OBJECT_SEARCH_DEARIS_CONTROLLER_DEVICE_TYPES as readonly string[]).includes(deviceType)) {
    return "dearisController";
  }
  return null;
}

/** 物件検索フロー対象の端末か（未選択・想定外の deviceType は false） */
export function isSupportedObjectSearchDeviceType(deviceType: DeviceType): boolean {
  return getObjectSearchRoute(deviceType) !== null;
}

/** 建物カード等：dearis* いずれかなら Controller 用カード */
export function isDearisObjectSearchDevice(deviceType: DeviceType): boolean {
  return getObjectSearchRoute(deviceType) === "dearisController";
}

/** GET /properties 検索時に付与する property_type（マンションのみ） */
export const PROPERTY_SEARCH_PROPERTY_TYPE = "mansion";

/** GET /properties 検索クエリ用 device_type */
export function propertySearchApiDeviceType(deviceType: DeviceType): string {
  const route = getObjectSearchRoute(deviceType);
  if (route === "PATMO") return "PATMO";
  if (route === "dearisController") return "dearisController";
  return "PabbitLite";
}
